export const request = (block: () => void) => {
  block();
};
